import TripCard from "./TripCard";

export default TripCard;